import React from 'react';
import ReferralServicesForm from 'pages/components/ReferralServicesForm';

const ARReferralServicesForm = (props) => (
  <ReferralServicesForm {...props} />
);

export default ARReferralServicesForm;
